import { UI, HStack } from '@genial/components';
import { Utils } from '@genial/utils';
import { Pressable } from 'native-base';
import { useCallback } from 'react';
import { Control, useFormContext } from 'react-hook-form';
import { NativeSyntheticEvent, TextInputFocusEventData } from 'react-native';

import { SearchFormData } from '../constants';

interface IOrderHistoryInput {
  handleClearSearch: () => void;
  handleSearchTerm: (data: SearchFormData) => void;
  isLoading: boolean;
  isMobile: boolean;
}

export const OrderHistoryInput = ({
  handleClearSearch,
  handleSearchTerm,
  isLoading,
  isMobile,
}: IOrderHistoryInput) => {
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useFormContext();

  const handleIsClear = useCallback((e: NativeSyntheticEvent<TextInputFocusEventData>) => {
    e.nativeEvent.text === '' && handleClearSearch();
  }, []);

  return (
    <HStack {...(isMobile && { alignItems: 'center', justifyContent: 'space-between' })} flex={1}>
      <HStack
        space={Utils.Responsive.PhoneTablet({
          phone: 'stack.xxs',
          tablet: 'inline.xxxs',
        })}
        width={Utils.Responsive.All({ phone: 'full', tablet: '50%', desktop: '30%' })}>
        <UI.Input
          testId="qa"
          noValidate={true}
          onSubmitEditing={handleSubmit(handleSearchTerm)}
          name="searchTerm"
          control={control as unknown as Control}
          error={errors.searchTerm}
          variant="rounded"
          isDisabled={isLoading}
          autoComplete="off"
          placeholder="Pesquise por ordem, cliente ou ativo"
          onBlur={handleIsClear}
          inputRightElement={
            <Pressable
              onPress={isValid ? handleClearSearch : null}
              pr={isValid ? 3 : 4}
              isDisabled={isLoading}>
              <UI.Icon testId="qa" name={isValid ? 'Close' : 'Search'} size="xxxs" />
            </Pressable>
          }
        />
        {!isMobile && (
          <UI.Button
            testID="qa"
            display={Utils.Responsive.PhoneTablet({ phone: 'none', tablet: 'flex' })}
            variant="primary"
            onPress={handleSubmit(handleSearchTerm)}
            isDisabled={!isValid || isLoading}>
            Buscar
          </UI.Button>
        )}
      </HStack>
    </HStack>
  );
};
